import { getBaseCurrency } from "@/constant/currency"
import { liveLobbyOf, normVendor } from "@/constant/liveLobby"
import * as S from './styled'

import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'i18next'
import api from '@/core/services/api'
import i18n from '@/constant/locales/i18n'
import { assetThumb } from '@/core/services/thumbUrl'
import { useCommonState } from '@/core/context/useContext'
import { usePopup } from '@/core/context/useWindow'
import { setMenuData } from '@/core/store/menu/actions'
import useTableData from '@/core/hooks/useTableData'
import useFormData from '@/core/hooks/useFormData'
import GameThumbnail from '@/components/GameThumbnail'
import SubTitleBadge from '@/components/SubTitleBadge'
import Login from '@/components/popup/Login'
import MHistory from '@/components/MHistory'
import iconsSprite from '@/assets/icons.svg'

import smPragmatic from '@/assets/images/small_logo/pragmatic_play.png'
import smMicrogaming from '@/assets/images/small_logo/microgaming.png'
import smPlayngo from '@/assets/images/small_logo/playngo.png'
import smCq9 from '@/assets/images/small_logo/cq9.png'
import smPlaytech from '@/assets/images/small_logo/PlayTech.png'
import smYggdrasil from '@/assets/images/small_logo/yggdrasil.png'
import smPgsoft from '@/assets/images/small_logo/pgsoft.png'
import smWazdan from '@/assets/images/small_logo/wazdan.png'
// 아래와 microgaming 은 Gold8 정사각 심볼(2026-10-22 받은 것, 144×144) — 화면에선 32×32 로 줄여 보인다
import smAsiaGaming from '@/assets/images/small_logo/asia-gaming.png'
import smAvatarux from '@/assets/images/small_logo/avatarux.png'
import smBigTimeGaming from '@/assets/images/small_logo/bigtimegaming.png'
import smBooongo from '@/assets/images/small_logo/booongo.png'
import smDragonsoft from '@/assets/images/small_logo/dragoonsoft.png'
import smEvoplay from '@/assets/images/small_logo/evoplay.png'
import smEzugi from '@/assets/images/small_logo/ezugi.png'
import smFantasma from '@/assets/images/small_logo/fantasma.png'
import smFatPanda from '@/assets/images/small_logo/fatpanda.png'
import smHabanero from '@/assets/images/small_logo/habanero.png'
import smHacksaw from '@/assets/images/small_logo/hacksaw.png'
import smJili from '@/assets/images/small_logo/jili.png'
import smNetent from '@/assets/images/small_logo/netent.png'
import smNolimit from '@/assets/images/small_logo/nolimit-city.png'
import smPeterSons from '@/assets/images/small_logo/peter-sons.png'
import smRedtiger from '@/assets/images/small_logo/redtiger.png'
import smRelax from '@/assets/images/small_logo/relax-gaming.png'
import smSexyBcrt from '@/assets/images/small_logo/sexybcrt.png'
import smSlotmill from '@/assets/images/small_logo/slotmill.png'
import smSplus from '@/assets/images/small_logo/splus.png'
import smVoltent from '@/assets/images/small_logo/voltent.png'
import smYolted from '@/assets/images/small_logo/yolted.png'

import lobbyEvolution from '@/assets/images/lobby/lobby_evolutiongaming.png'
import lobbyMicrogaming from '@/assets/images/lobby/lobby_microgaming.png'
import lobbyPlaytech from '@/assets/images/lobby/lobby_playtech.png'
import lobbyPragmatic from '@/assets/images/lobby/lobby_pragamatic.png'

/** 벤더 로고 별칭 — 같은 게임사를 빌드/사이트마다 다르게 부른다.
 *  일본(grand-line)은 가타카나, 한국(hubsolution·xxx)은 한글이나 영문 약자(PP·MG·PT…)로
 *  등록돼 있어, 이름을 정규화(대문자·공백/구분자 제거)한 뒤 별칭으로 찾는다.
 *  ⚠️ EVO(Evolution, 라이브)와 EVOPLAY(슬롯)는 다른 회사다. 섞지 말 것. */
const VENDOR_LOGO_ALIASES = [
  [smPragmatic,  ['プラグマティック', '프라그마틱', '프라그마틱플레이', 'PP', 'PRAGMATIC', 'PRAGMATICPLAY']],
  [smMicrogaming,['マイクロゲーミング', '마이크로게이밍', 'MG', 'MICROGAMING']],
  [smPlayngo,    ['プレインゴー', '플레이앤고', 'PLAYNGO', "PLAY'NGO", 'PNG']],
  [smNolimit,    ['ノーリミット・シティ', '노리밋시티', 'NOLIMIT', 'NOLIMITCITY', 'NLC']],
  [smJili,       ['JILI', '질리', '지리', 'JL']],
  [smCq9,        ['CQ9', '씨큐나인']],
  [smPlaytech,   ['プレイテック', '플레이테크', 'PT', 'PLAYTECH']],
  [smHacksaw,    ['ハクソー', '핵소', 'HACKSAW', 'HACKSAWGAMING', 'HS']],
  [smYggdrasil,  ['ユグドラシル', '이그드라실', 'YGGDRASIL', 'YGG']],
  [smHabanero,   ['ハバネロ', '하바네로', 'HABANERO', 'HB']],
  [smRelax,      ['릴렉스', 'RELAX', 'RELAXGAMING']],
  [smBooongo,    ['ブウンゴ', '부운고', 'BNG', 'BOOONGO']],
  [smWazdan,     ['ワズダン', '와즈단', 'WAZDAN']],
  [smRedtiger,   ['レッド・タイガー', '레드타이거', 'REDTIGER']],
  [smPgsoft,     ['PG', 'PGSOFT', '피지소프트', 'POCKETGAMESSOFT']],
  [smAsiaGaming, ['プレイエース（旧 アジアゲーミング）', 'PLAYACE', '플레이에이스', 'ASIAGAMING', '아시아게이밍']],
  [smAvatarux,   ['アバターUX', '아바타UX', 'AVATARUX']],
  [smDragonsoft, ['ドラグーンソフト', '드라군소프트', 'DRAGOONSOFT', 'DRAGONSOFT']],
  [smEvoplay,    ['エボプレイ', '에보플레이', 'EVOPLAY']],
  [smBigTimeGaming, ['BIGTIMEGAMING', 'BTG', '빅타임게이밍']],
  [smEzugi,      ['EZUGI', '이주기']],
  [smFantasma,   ['FANTASMA', '판타스마']],
  [smFatPanda,   ['FATPANDA', '팻판다']],
  [smNetent,     ['NETENT', '넷엔트']],
  [smPeterSons,  ['PETERSONS', 'PETER&SONS', '피터앤선즈']],
  [smSexyBcrt,   ['SEXYBCRT', 'AESEXY', 'SEXY', '섹시바카라']],
  [smSlotmill,   ['SLOTMILL', '슬롯밀']],
  [smSplus,      ['SPLUS', '에스플러스']],
  [smVoltent,    ['VOLTENT', '볼트엔트']],
  [smYolted,     ['YOLTED', '욜티드']],
]

/** 표기 차이를 흡수: 대문자화 + 공백·언더바·하이픈·중점 제거 */

const SMALL_LOGO_MAP = VENDOR_LOGO_ALIASES.reduce((acc, [logo, names]) => {
  names.forEach((n) => { acc[normVendor(n)] = logo })
  return acc
}, {})

/** 벤더명으로 소형 로고 찾기(없으면 undefined → 이름만 표시) */
const smallLogoOf = (name) => SMALL_LOGO_MAP[normVendor(name)]

const LOBBY_LOGO_MAP = {
  'エボリューション': lobbyEvolution,
  'Evolution': lobbyEvolution,
  'evolution': lobbyEvolution,
  'マイクロゲーミング': lobbyMicrogaming,
  'Microgaming': lobbyMicrogaming,
  'microgaming': lobbyMicrogaming,
  'プレイテック': lobbyPlaytech,
  'Playtech': lobbyPlaytech,
  'playtech': lobbyPlaytech,
  'プラグマティック': lobbyPragmatic,
  'Pragmatic': lobbyPragmatic,
  'pragmatic': lobbyPragmatic,
}

// 사이드바 게임사 약어 (menu_code 기준)
/* VENDOR_ABBR(메뉴코드 → 약칭) 제거.
   grand-line 의 메뉴코드 기준으로 만든 표인데 사이트마다 코드가 달라, site 6 에서는
   01_02_09(PP)를 'NLC', 01_02_10(MG)을 'PNG' 로 표시하는 등 이름이 전부 어긋났다.
   벤더명은 DB(menu_game_category.name)를 그대로 쓴다. */

const TAB_KEYS = ['new', 'popular', 'all']
const TAB_LABEL_KEYS = ['gameList.new', 'gameList.popular', 'gameList.allGames']
const PAGE_SIZE = 9999 // 페이지네이션 없이 전체 게임을 한 번에 표시
const SKELETON_COUNT = 12

export default function MGameListPage() {
  const { menuCode } = useParams()
  const navigate = useNavigate()
  const { isLogin } = useCommonState()
  const { openPopup } = usePopup()
  const dispatch = useDispatch()
  const menuData = useSelector((state) => state.Menu)

  // 사이드 메뉴는 모바일 메인(/m)에서만 적재한다. 이 페이지로 바로 들어오거나(URL 직접 진입·새로고침)
  //   메인을 거치지 않으면 menuData 가 비어 어사이드 게임사 목록이 통째로 사라진다. 없으면 직접 받는다.
  useEffect(() => {
    if (Array.isArray(menuData) && menuData.length) return
    api.get('/game/side-menu')
      .then((res) => dispatch(setMenuData(res?.data?.content?.side_menu || [])))
      .catch((err) => console.error('사이드 메뉴 조회 실패:', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  const [activeCategory, setActiveCategory] = useState(menuCode?.startsWith('01_01') ? '01_01_detail' : '01_02')
  // side_menu 최상위가 [01_02, 01_01] 형태 또는 [01 > subMenus] 형태 모두 대응
  const findNode = (code) =>
    menuData?.find?.(m => m.menuCode === code) ||
    menuData?.[0]?.subMenus?.find?.(m => m.menuCode === code)
  const slotVendors = findNode('01_02')?.subMenus || []
  const liveVendors = findNode('01_01')?.subMenus || []
  const allVendors = activeCategory === '01_01_detail' ? liveVendors : slotVendors
  const [activeVendor, setActiveVendor] = useState(menuCode || allVendors[0]?.menuCode || '')
  const [activeTab, setActiveTab] = useState('popular')
  // 인기(또는 신규) 지정 게임이 하나도 없으면 빈 화면 대신 전체 게임으로 넘긴다 — 게임사마다 한 번
  const fellBackRef = useRef('')
  const [searchValue, setSearchValue] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const [categoryMobileLiveThumbnail, setCategoryMobileLiveThumbnail] = useState(null)

  // 활성 벤더 썸네일 (PC 모달 상단 단일 이미지와 동일)
  const activeVendorObj = useMemo(
    () => allVendors.find(v => v.menuCode === activeVendor),
    [allVendors, activeVendor],
  )

  useEffect(() => {
    if (menuCode && menuCode !== activeVendor) setActiveVendor(menuCode)
  }, [menuCode])

  // 검색어 디바운스 (keystroke마다 API 호출 방지)
  useEffect(() => {
    const tid = setTimeout(() => setDebouncedSearch(searchValue), 300)
    return () => clearTimeout(tid)
  }, [searchValue])

  const getData = useTableData(true, PAGE_SIZE)
  // 첫 화면에서 같은 조회가 겹쳐 나가고, 인기 없는 게임사는 전체로 넘어가며 또 조회한다.
  //   늦게 온 옛 응답(빈 인기 목록)이 전체 목록을 덮으면 '등록된 게임이 없다'가 뜨므로 마지막 요청의 응답만 반영한다.
  const requestSeq = useRef(0)
  // 게임사·탭을 바꾸면 새 목록이 올 때까지 이전 목록을 흐리게 둔다(비웠다 채우면 높이가 출렁인다)
  const [switching, setSwitching] = useState(false)

  const handleGetData = () => {
    if (!activeVendor) return
    const seq = ++requestSeq.current

    const params = {
      ...getData.extendData.pagingData,
      lang: i18n.language,
      menu_code: activeVendor,
      title: debouncedSearch || '',
    }

    if (activeTab === 'new') params.is_new = 'Y'
    else if (activeTab === 'popular') params.is_popular = 'Y'

    api
      .get('/game/side-menu/game', { params })
      .then((res) => {
        if (seq !== requestSeq.current) return
        const content = res.data?.content || {}
        // 서버는 game_list 를 { content, pageHelperDto } 로 감싸 내려준다(BaseDao 자동 페이징).
        //   구버전 응답(배열 직접)도 있어 PC(pages/Lobby)와 동일하게 양쪽을 받는다.
        //   이 처리를 빼면 객체가 그대로 들어가 games.map 에서 죽는다.
        const gameList = content.game_list?.content || content.game_list || []
        const arr = Array.isArray(gameList) ? gameList : []
        if (!arr.length && activeTab !== 'all' && !debouncedSearch && fellBackRef.current !== activeVendor) {
          fellBackRef.current = activeVendor
          setActiveTab('all')
          return
        }
        getData.setData(arr)
        setSwitching(false)
        getData.setPagingInfo(content.game_list?.pageHelperDto || content.pageHelperDto)
        setCategoryMobileLiveThumbnail(content.mobile_live_thumbnail || null)
      })
      .catch((err) => {
        if (seq !== requestSeq.current) return
        console.error('게임 목록 조회 실패:', err)
        setSwitching(false)
        getData.setData([])
        getData.setError(true)
      })
  }

  useFormData({}, handleGetData, getData)

  // 벤더/탭/검색 변경 시 page=1 리셋 → fnSearch 자동 호출. 스켈레톤은 처음 한 번만(이후엔 이전 목록을 흐리게 두고 바꾼다)
  useEffect(() => {
    setSwitching(true)
    getData.setExtendData({
      pagingData: { page: 1, countPerPage: PAGE_SIZE },
      sortNm: '',
    })
  }, [activeVendor, activeTab, debouncedSearch])

  const handleCategoryChange = (cat) => {
    setActiveCategory(cat)
    const vendors = cat === '01_02' ? slotVendors : liveVendors
    const first = vendors[0]?.menuCode || ''
    setActiveVendor(first)
    setActiveTab('popular')
    setSearchValue('')
    if (cat === '01_02' && first) navigate(`/m/game-list/${first}`, { replace: true })
  }

  const handleVendorClick = (code) => {
    setActiveVendor(code)
    setActiveTab('popular')
    setSearchValue('')
    navigate(`/m/game-list/${code}`, { replace: true })
  }

  const handleGameClick = (game) => {
    if (!isLogin) {
      openPopup({ grandLogin: true, title: t('modalTitle.login'), content: <Login isMobile /> })
      return
    }
    // 슬롯 게임은 '戻る' 시 이 벤더 목록 페이지로 돌아오도록 vendorIndex/category 전달
    navigate(`/m/game-play/${game.vendor}/${game.id}/${getBaseCurrency()}`, {
      state: {
        vendorIndex: activeVendor,
        category: activeCategory === '01_02' ? 'slot' : 'live',
      },
    })
  }

  const handleLobbyClick = (vendor) => {
    if (!isLogin) {
      openPopup({ grandLogin: true, title: t('modalTitle.login'), content: <Login isMobile /> })
      return
    }
    const entry = liveLobbyOf(vendor.name)
    if (entry) {
      navigate(`/m/game-play/${entry.vendor}/${entry.id}/${getBaseCurrency()}`)
      return
    }
    // 로비가 없는 라이브 게임사는 그 게임사의 게임 목록으로
    if (vendor?.menuCode) {
      setActiveCategory('01_01_detail')
      setActiveVendor(vendor.menuCode)
      setActiveTab('all')
      return
    }
    openPopup({
      title: t('gameList.no_lobby_title', { defaultValue: 'お知らせ' }),
      content: t('gameList.no_lobby', { defaultValue: 'ロビーが見つかりません。' }),
    })
  }

  const isInitialLoading = getData.data === null
  const games = getData.data || []
  const isLiveGrid = activeCategory === '01_01'
  const bannerId = (activeCategory === '01_01_detail' && categoryMobileLiveThumbnail) || activeVendorObj?.vendorThumbnail
  const catLabel = activeCategory === '01_02' ? t('gameList.slot') : t('gameList.liveCasino')

  // gold8.bet 모바일 게임 목록 모양 — 사이트 머리·바닥 없이 위 띠(뒤로가기 + 분류 탭)부터 시작
  return (
    <S.Page>
      <S.TopBar>
        <S.Back type="button" aria-label="back" onClick={() => navigate('/m')}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" /></svg>
        </S.Back>
        <S.CatTab type="button" $on={activeCategory === '01_02'} onClick={() => handleCategoryChange('01_02')}>{t('gameList.slot')}</S.CatTab>
        <S.CatTab type="button" $on={activeCategory !== '01_02'} onClick={() => handleCategoryChange('01_01')}>{t('gameList.liveCasino')}</S.CatTab>
      </S.TopBar>

      {/* 라이브카지노: 동그란 게임사 그림 3열 — 누르면 게임사 라이브 로비 */}
      {isLiveGrid && (
        <S.LiveGrid>
          {liveVendors.map((v) => {
            const lobbyImg = LOBBY_LOGO_MAP[v.name]
              || Object.entries(LOBBY_LOGO_MAP).find(([key]) => v.name?.toLowerCase().includes(key.toLowerCase()))?.[1]
            const imgSrc = (v.mobileLiveThumbnail ? assetThumb(v.mobileLiveThumbnail, 500) : null)
              || lobbyImg
              || (v.thumbnail ? assetThumb(v.thumbnail, 500) : null)
            return (
              <S.LiveItem key={v.menuCode} type="button" onClick={() => handleLobbyClick(v)}>
                {imgSrc ? <img src={imgSrc} alt="" loading="lazy" decoding="async" /> : <S.LivePlaceholder />}
                <span>{v.name} {t('gameList.liveCasino')}</span>
              </S.LiveItem>
            )
          })}
        </S.LiveGrid>
      )}

      {/* 슬롯 · 라이브 게임사 상세: 배너 + 왼쪽 게임사 카드 + 오른쪽 게임 */}
      {!isLiveGrid && (
        <>
          <S.Body>
            <S.Side>
              {allVendors.map((v) => (
                <S.VendorCard key={v.menuCode} type="button" $on={activeVendor === v.menuCode} onClick={() => handleVendorClick(v.menuCode)}>
                  {smallLogoOf(v.name) && <img src={smallLogoOf(v.name)} alt="" />}
                  <span>{v.name} {catLabel}</span>
                </S.VendorCard>
              ))}
            </S.Side>

            <S.Main>
              {/* 게임사 배너는 오른쪽 목록 위에 둔다 — 위에 걸쳐 두면 배너 있는 게임사(MG·PP·JL)와 없는 곳을 오갈 때
                  왼쪽 게임사 목록까지 통째로 오르내렸다. 자리(850×250)는 이미지가 오기 전에 잡아 둔다 */}
              {bannerId && <S.Banner src={assetThumb(bannerId, 1000)} alt="" width={850} height={250} />}
              <S.SearchRow onSubmit={(e) => e.preventDefault()}>
                <input
                  type="text"
                  value={searchValue}
                  onChange={e => { setSearchValue(e.target.value); setActiveTab('all') }}
                  placeholder={t('gameList.searchPlaceholder')}
                />
                <button type="submit">
                  <svg viewBox="0 0 47 47" aria-hidden="true"><use href={`${iconsSprite}#ico-sch`} /></svg>
                  {t('gold.search')}
                </button>
              </S.SearchRow>

              <S.Tabs role="tablist">
                {TAB_KEYS.map((key, i) => (
                  <S.Tab key={key} type="button" role="tab" aria-selected={activeTab === key} $on={activeTab === key} onClick={() => setActiveTab(key)}>
                    {t(TAB_LABEL_KEYS[i])}
                  </S.Tab>
                ))}
              </S.Tabs>

              <S.SectionTitle>
                <span>{activeTab === 'all' ? t('gameList.allGames') : `${t(TAB_LABEL_KEYS[TAB_KEYS.indexOf(activeTab)])}${t('gold.gameWord')}`}</span>
              </S.SectionTitle>

              {isInitialLoading ? (
                <S.Grid>{Array.from({ length: SKELETON_COUNT }).map((_, i) => <S.Thumb key={i} />)}</S.Grid>
              ) : games.length ? (
                <S.Grid $dim={switching}>
                  {games.map((game, i) => (
                    <S.Game key={game.id || i} type="button" onClick={() => handleGameClick(game)}>
                      <S.Thumb>
                        <GameThumbnail src={game.thumbnail || ''} alt={game.title || ''} />
                        <SubTitleBadge text={game.sub_title} />
                      </S.Thumb>
                      <S.GameName>{game.title}</S.GameName>
                    </S.Game>
                  ))}
                </S.Grid>
              ) : (
                <S.Empty>{t('gold.noData')}</S.Empty>
              )}
            </S.Main>
          </S.Body>
        </>
      )}

      <MHistory />
    </S.Page>
  )
}
